import { TFunction } from '@mint-lib/i18n';

import { getIsDataFileContextFilled } from '../../../utils/dataFileUtils.jsx';
import { isPlatformFieldRequiredForTemplateDuplicate } from './isPlatformFieldRequiredForTemplateDuplicate.js';
import type { FormValues } from './types.js';

export const validateForm = ({
  t,
  formValues,
  isImportHubV2,
}: {
  t: TFunction;
  formValues: FormValues;
  isImportHubV2: boolean;
}) => {
  if (!formValues.name) {
    return t('The template name is not filled');
  }

  const isPricingItemLevel = isPlatformFieldRequiredForTemplateDuplicate(
    formValues.granularityLevel,
  );

  const isIngestionContextFilled = getIsDataFileContextFilled({
    context: formValues,
    isImportHubV2,
    isPricingItemLevel,
  });

  if (!isIngestionContextFilled) {
    return t(
      `Please fulfill the obligatory ingestion context before processing.`,
    );
  }
  if (!formValues.dateOrder || !formValues.numberFormat) {
    return t(
      `Fill in the Number format in the header's selection step for accurate mapping of number-related data`,
    );
  }

  const requiredMetrics = formValues.headerOptions.filter(
    (header) => header.required,
  );

  const isRequiredMetricsSelected = requiredMetrics.every((metric) => {
    return formValues.headers.find(
      (header) => header.mappedHeaderName === metric.name,
    );
  });
  const isMetricSelected = formValues.headers.some((templateHeader) =>
    ['metric', 'custom_metric'].includes(
      formValues.headerOptions.find(
        (headerOption) => headerOption.name === templateHeader.mappedHeaderName,
      )?.headerType ?? '',
    ),
  );

  if (!isRequiredMetricsSelected || !isMetricSelected) {
    return t('Map obligatory dimensions and at least one metric to proceed.');
  }

  if (formValues.headers.some((header) => !header.rawHeader)) {
    return t('Please ensure no file header field is left empty to proceed.');
  }

  return null;
};
